function initAnchorNav(){
    if($(".anchor-nav").length > 0){
        if(!$("html").hasClass("smoothScrolling")){
            $("html").addClass("smoothScrolling");
        }
    }
}